import IconHamburgerMenu from '@creditflowresearch/uilib/Icon/IconHamburgerMenu';
import IconClose from '@creditflowresearch/uilib/Icon/IconClose';

import styles from './hamburgerButton.module.scss';

interface IHamburgerButtonProps {
  isOpen: boolean,
  onClick: () => void,
  dataTest?: string,
}

const HamburgerButton = ({ isOpen, onClick, dataTest = 'hamburgerButton' }: IHamburgerButtonProps) => (
  <button
    className={ styles.hamburgerButton }
    onClick={ (e) => {
      e.stopPropagation();
      onClick();
    } }
    type="button"
    aria-label={ isOpen ? 'Close menu' : 'Open menu' }
    data-test={ dataTest }
  >
    { isOpen ? (
      <IconClose className={ styles.icon } />
    ) : (
      <IconHamburgerMenu className={ styles.icon } />
    ) }
  </button>
);

export default HamburgerButton;
